export class ShareService {
  private navigator: Navigator

  constructor (navigator: Navigator) {
    this.navigator = navigator
  }

  public isClipboardApiAvailable (): boolean {
    return this.navigator.clipboard !== undefined
  }

  public isShareApiAvailable (): boolean {
    return this.navigator.share !== undefined
  }

  public canShare (): boolean {
    return this.isShareApiAvailable() || this.isClipboardApiAvailable()
  }

  public async share (title: string, url: string): Promise<void> {
    if (this.navigator.share !== undefined) {
      await this.navigator.share({
        text: title,
        url,
      })
    } else if (this.navigator.clipboard !== undefined) {
      await this.navigator.clipboard.writeText(url)
    }
  }
}
